export function formatRut(rut: string): string {
  const cleaned = rut.replace(/[^0-9kK]/g, "")

  if (cleaned.length < 2) return cleaned

  const dv = cleaned.slice(-1)
  const numbers = cleaned.slice(0, -1)

  const formatted = numbers.replace(/\B(?=(\d{3})+(?!\d))/g, ".")

  return `${formatted}-${dv}`
}

export function validateRut(rut: string): boolean {
  const cleaned = rut.replace(/[^0-9kK]/g, "")

  if (cleaned.length < 2) return false

  const dv = cleaned.slice(-1).toUpperCase()
  const numbers = cleaned.slice(0, -1)

  let sum = 0
  let multiplier = 2

  for (let i = numbers.length - 1; i >= 0; i--) {
    sum += Number.parseInt(numbers[i] ?? "0") * multiplier
    multiplier = multiplier === 7 ? 2 : multiplier + 1
  }

  const remainder = sum % 11
  const calculatedDv = remainder === 0 ? "0" : remainder === 1 ? "K" : String(11 - remainder)

  return dv === calculatedDv
}

export function parseRut(rut: string): { rut: number; dv: string } | null {
  const cleaned = rut.replace(/[^0-9kK]/g, "")

  if (cleaned.length < 2) return null

  const dv = cleaned.slice(-1).toUpperCase()
  const numbers = Number.parseInt(cleaned.slice(0, -1))

  if (isNaN(numbers)) return null

  return { rut: numbers, dv }
}

export function formatRutFromParts(rut: number, dv: string): string {
  const rutStr = rut.toString()
  const formatted = rutStr.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
  return `${formatted}-${dv.toUpperCase()}`
}
